import React  from 'react';
import FormMasterDirecto from './FormMasterDirecto';

export default FormMasterDirecto;